import { createContext, useContext, useState } from 'react';

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSiteState] = useState(() => {
    try { return JSON.parse(localStorage.getItem('lidwork_site')); } catch { return null; }
  });
  function setSite(s) {
    if (s) localStorage.setItem('lidwork_site', JSON.stringify({ id: s.id, nom: s.nom }));
    else localStorage.removeItem('lidwork_site');
    setSiteState(s ? { id: s.id, nom: s.nom } : null);
  }
  return <SiteCtx.Provider value={{ site, setSite }}>{children}</SiteCtx.Provider>;
}
export const useSite = () => useContext(SiteCtx);
